/* Cartes produits v2 (23/09/2026) — défilement des images de la carte au survol.
   Ordinateur avec souris seulement. Toutes les 1,5 s : image suivante (4 max),
   points indicateurs (.bn-dots) ; images 3-4 chargées au premier survol,
   montrées seulement après leur load, retirées de la rotation si erreur ;
   à la sortie, retour à l'image 1 et arrêt. Délégation sur mouseover : couvre
   aussi les cartes injectées après coup (filtres, recommandations, recherche). */
(function () {
  if (window.bnCardsInit) return;
  window.bnCardsInit = true;
  if (!window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;
  var INTERVAL = 1500;

  function setup(wrap) {
    var dots = wrap.querySelector('.bn-dots');
    if (!dots) return null;
    var media = dots.parentElement;
    var imgs = media.querySelectorAll(':scope > img');
    var n = Math.min(imgs.length, 4);
    if (n < 3) return null;
    var dot = dots.querySelectorAll('.bn-dot');
    var timer = null, idx = 0, loaded = false;
    // Rotation limitée aux images prêtes : 1-2 (natives), 3-4 seulement après
    // leur événement load ; une image en erreur n'y entre jamais.
    var ready = [0, 1];
    for (var k = 2; k < n; k++) { if (dot[k]) dot[k].hidden = true; }
    function show(i) {
      idx = i;
      media.setAttribute('data-bn-slide', i);
      dot.forEach(function (d, k) { d.classList.toggle('bn-dot--active', k === i); });
    }
    function next() {
      var p = ready.indexOf(idx);
      return ready[(p + 1) % ready.length];
    }
    function onLoad(im, i) {
      if (!im.naturalWidth) return onError(im, i);
      im.classList.add('bn-slide-img--ok');
      if (ready.indexOf(i) === -1) {
        ready.push(i);
        ready.sort(function (a, b) { return a - b; });
      }
      if (dot[i]) dot[i].hidden = false;
    }
    function onError(im, i) {
      im.classList.remove('bn-slide-img--ok');
      im.classList.add('bn-slide-img--broken');
      var p = ready.indexOf(i);
      if (p !== -1) ready.splice(p, 1);
      if (dot[i]) dot[i].hidden = true;
      if (idx === i) show(next());
    }
    function enter() {
      if (timer) return;
      if (!loaded) {
        loaded = true;
        imgs.forEach(function (im, i) {
          if (i < 2 || i >= n || !im.dataset.bnSrc) return;
          im.addEventListener('load', function () { onLoad(im, i); });
          im.addEventListener('error', function () { onError(im, i); });
          im.srcset = im.dataset.bnSrcset;
          im.src = im.dataset.bnSrc;
          im.removeAttribute('data-bn-srcset');
          im.removeAttribute('data-bn-src');
        });
      }
      show(1);
      timer = setInterval(function () { show(next()); }, INTERVAL);
    }
    function leave() {
      clearInterval(timer);
      timer = null;
      media.removeAttribute('data-bn-slide');
      dot.forEach(function (d) { d.classList.remove('bn-dot--active'); });
    }
    wrap.addEventListener('mouseenter', enter);
    wrap.addEventListener('mouseleave', leave);
    return enter;
  }

  document.addEventListener('mouseover', function (e) {
    var wrap = e.target.closest && e.target.closest('.card-wrapper.product-card-wrapper');
    if (!wrap || wrap.bnSlides) return;
    wrap.bnSlides = true;
    var enter = setup(wrap);
    if (enter) enter();
  });
})();
